export enum PolicyAttachmentType {
  // Billing
  NewBusinessPaymentSchedule = 'newBusinessPaymentSchedule',
  RenewalPaymentSchedule = 'renewalPaymentSchedule',
  PolicyChangePaymentSchedule = 'policyChangePaymentSchedule',
  ReissuePaymentSchedule = 'reissuePaymentSchedule',
  RewritePaymentSchedule = 'rewritePaymentSchedule',
  ReinstatementPaymentSchedule = 'reinstatementPaymentSchedule',
  PaymentScheduleNoPolicyTransaction = 'paymentScheduleNoPolicyTransaction',
  BillingWithdrawalRejectionNotice = 'billingWithdrawalRejectionNotice',
  BillingOverduePaymentNotice = 'billingOverduePaymentNotice',
  BillingFinalBillNotice = 'billingFinalBillNotice',
  BillingRefundIssued = 'billingRefundIssued',
  PaymentReceivedPolicyReinstated = 'paymentReceivedPolicyReinstated',
  PaymentRequiredOutstandingBalance = 'paymentRequiredOutstandingBalance',
  BillingCollectionNotice = 'billingCollectionNotice',
  BillingCreditCardExpired = 'billingCreditCardExpired',

  // Cancellation
  InsurerNonRenewal = 'insurerNonRenewal',
  InsurerCancellationReinstatable = 'insurerCancellationReinstatable',
  InsurerCancellationDefinitive = 'insurerCancellationDefinitive',
  InsuredCancellationRequest = 'insuredCancellationRequest',
  InsurerCancellation = 'insurerCancellation',

  // Policy transaction
  NewBusinessPolicyDeclaration = 'newBusinessPolicyDeclaration',
  NewBusinessLiabilityCertificates = 'newBusinessLiabilityCertificates',
  RenewalPolicyDeclaration = 'renewalPolicyDeclaration',
  RenewalLiabilityCertificates = 'renewalLiabilityCertificates',
  PolicyChangePolicyDeclaration = 'policyChangePolicyDeclaration',
  PolicyChangeLiabilityCertificates = 'policyChangeLiabilityCertificates',
  ReissuePolicyDeclaration = 'reissuePolicyDeclaration',
  ReissueLiabilityCertificates = 'reissueLiabilityCertificates',
  RewritePolicyDeclaration = 'rewritePolicyDeclaration',
  RewriteLiabilityCertificates = 'rewriteLiabilityCertificates',
  ReinstatementPolicyDeclaration = 'reinstatementPolicyDeclaration',
  ReinstatementLiabilityCertificates = 'reinstatementLiabilityCertificates',

  // Underwriting
  UnderwritingRequest = 'underwritingRequest',

  // Claim
  ClaimOpeningNotice = 'claimOpeningNotice',
  ClaimClosingNotice = 'claimClosingNotice',
  ClaimAdjusterAssignment = 'claimAdjusterAssignment',
  ClaimAutoRentalNotice = 'claimAutoRentalNotice',
  ClaimTotalLossNotice = 'claimTotalLossNotice',
  ClaimAutoFaultDeterminationNotice = 'claimAutoFaultDeterminationNotice',
  ClaimPaymentNotice = 'claimPaymentNotice',

  // Youset
  PolicyContract = 'policyContract',
  BillingStatement = 'billingStatement',
  BillingNotice = 'billingNotice',
  CancellationNotice = 'cancellationNotice',
  OkEDelivery = 'okEDelivery',
  Unknown = 'unknown',
}
